/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PhaseFinancialBreakdownType = "NO_PHASE" | "OFFSET" | "PHASE" | "PROJECT_TIME_REG" | "%future added value";
export type MonthByMonthPhaseLoader_viewer = {
    readonly id: string;
    readonly company: {
        readonly currency: string | null;
    } | null;
    readonly project: {
        readonly aggregatedPhaseFinancialBreakdown: ReadonlyArray<{
            readonly breakdownType: PhaseFinancialBreakdownType | null;
            readonly phase: {
                readonly id: string;
                readonly name: string | null;
                readonly startDay: number | null;
                readonly startMonth: number | null;
                readonly startYear: number | null;
            } | null;
            readonly aggregatedFinancialNumbers: ReadonlyArray<string | null> | null;
        } | null>;
        readonly timeAggregatedFinancialNumbers: ReadonlyArray<{
            readonly breakdownType: PhaseFinancialBreakdownType | null;
            readonly phase: {
                readonly id: string;
                readonly name: string | null;
                readonly startDay: number | null;
                readonly startMonth: number | null;
                readonly startYear: number | null;
            } | null;
            readonly timeAggregatedFinancialNumbers: ReadonlyArray<string | null> | null;
        } | null>;
        readonly expenseAggregatedFinancialNumbers: ReadonlyArray<{
            readonly breakdownType: PhaseFinancialBreakdownType | null;
            readonly phase: {
                readonly id: string;
                readonly name: string | null;
                readonly startDay: number | null;
                readonly startMonth: number | null;
                readonly startYear: number | null;
            } | null;
            readonly expenseAggregatedFinancialNumbers: ReadonlyArray<string | null> | null;
        } | null>;
    } | null;
    readonly " $refType": "MonthByMonthPhaseLoader_viewer";
};
export type MonthByMonthPhaseLoader_viewer$data = MonthByMonthPhaseLoader_viewer;
export type MonthByMonthPhaseLoader_viewer$key = {
    readonly " $data"?: MonthByMonthPhaseLoader_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"MonthByMonthPhaseLoader_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "aggregateLevel",
  "value": "MONTH"
},
v2 = {
  "items": [
    {
      "kind": "Variable",
      "name": "aggregates.0",
      "variableName": "selectedSingleValue"
    }
  ],
  "kind": "ListValue",
  "name": "aggregates"
},
v3 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v4 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v5 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v6 = {
  "kind": "Variable",
  "name": "excludeOpportunityActuals",
  "variableName": "excludeOpportunityActuals"
},
v7 = {
  "kind": "Literal",
  "name": "filterRowsWithNoValues",
  "value": true
},
v8 = {
  "kind": "Variable",
  "name": "ignoreBaselineWinChance",
  "variableName": "ignoreBaselineWinChance"
},
v9 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v10 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v11 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "breakdownType",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "PhaseType",
  "kind": "LinkedField",
  "name": "phase",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startYear",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "timeSearchQuery",
      "type": "TaskSearchQueryType!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "expenseSearchQuery",
      "type": "TaskSearchQueryType!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startYear",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startMonth",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDay",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endYear",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endMonth",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDay",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "ID!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "selectedSingleValue",
      "type": "FinancialAggregatedNumber!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "ignoreBaselineWinChance",
      "type": "Boolean"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeOpportunityActuals",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MonthByMonthPhaseLoader_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "concreteType": "AggregatedPhaseFinancialBreakdown",
          "kind": "LinkedField",
          "name": "aggregatedPhaseFinancialBreakdown",
          "plural": true,
          "selections": [
            (v12/*: any*/),
            (v13/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "aggregatedFinancialNumbers",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "timeAggregatedFinancialNumbers",
          "args": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            {
              "kind": "Variable",
              "name": "searchQuery",
              "variableName": "timeSearchQuery"
            },
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "concreteType": "AggregatedPhaseFinancialBreakdown",
          "kind": "LinkedField",
          "name": "aggregatedPhaseFinancialBreakdown",
          "plural": true,
          "selections": [
            (v12/*: any*/),
            (v13/*: any*/),
            {
              "alias": "timeAggregatedFinancialNumbers",
              "args": null,
              "kind": "ScalarField",
              "name": "aggregatedFinancialNumbers",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "expenseAggregatedFinancialNumbers",
          "args": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            {
              "kind": "Variable",
              "name": "searchQuery",
              "variableName": "expenseSearchQuery"
            },
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "concreteType": "AggregatedPhaseFinancialBreakdown",
          "kind": "LinkedField",
          "name": "aggregatedPhaseFinancialBreakdown",
          "plural": true,
          "selections": [
            (v12/*: any*/),
            (v13/*: any*/),
            {
              "alias": "expenseAggregatedFinancialNumbers",
              "args": null,
              "kind": "ScalarField",
              "name": "aggregatedFinancialNumbers",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = 'ceed56b451d610a7655fdc58029a529c';
export default node;
